import { useTranslation } from 'react-i18next';
import type { ReportStyleSettings } from './types';

interface ReportSummaryBarProps {
  totalControllers: number;
  totalZones: number;
  zonesWithIssues: number;
  zonesWithPhotos: number;
  totalDoubleChecks: number;
  doubleChecksWithIssues: number;
  styleSettings: ReportStyleSettings;
}

export function ReportSummaryBar({
  totalControllers,
  totalZones,
  zonesWithIssues,
  zonesWithPhotos,
  totalDoubleChecks,
  doubleChecksWithIssues,
  styleSettings,
}: ReportSummaryBarProps) {
  const { t } = useTranslation('inspection');
  const stats = [
    { label: t('report.summaryControllers'), value: totalControllers },
    { label: t('report.summaryTotalZones'), value: totalZones },
    { label: t('report.summaryZoneIssues'), value: zonesWithIssues, highlight: zonesWithIssues > 0 },
    { label: t('report.summaryPhotos'), value: zonesWithPhotos },
    { label: t('report.summaryDoubleChecks'), value: totalDoubleChecks },
    { label: t('report.summaryDcIssues'), value: doubleChecksWithIssues, highlight: doubleChecksWithIssues > 0 },
  ];

  return (
    <div
      className="report-summary-bar"
      style={{
        backgroundColor: styleSettings.summary_bg_color,
        borderBottom: `1px solid ${styleSettings.border_color}`,
      }}
    >
      {stats.map((stat, idx) => (
        <div key={stat.label} className="report-summary-stat">
          <span className="report-summary-label" style={{ color: styleSettings.info_label_color }}>
            {stat.label}
          </span>
          <span
            className="report-summary-value"
            style={{
              color: stat.highlight ? styleSettings.summary_highlight_color : styleSettings.summary_text_color,
            }}
          >
            {stat.value}
          </span>
          {idx < stats.length - 1 && (
            <span className="report-summary-divider" style={{ backgroundColor: styleSettings.border_color }} />
          )}
        </div>
      ))}
    </div>
  );
}
